import { render, staticRenderFns } from "./PromoCodeSlices.vue?vue&type=template&id=08717ba5&"
import script from "./PromoCodeSlices.vue?vue&type=script&lang=js&"
export * from "./PromoCodeSlices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports